// AUTO-GENERATED SQL Builder (V40 Final) for BookingMilestoneShare
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class BookingMilestoneShareSql {
  private ast = new SqlAst('BookingMilestoneShare', 'bookingMilestoneShare');
  public readonly main: any = {};

  public guid: SqlField;
  public bookingMilestoneId: SqlField;
  public bookingPackageId: SqlField;
  public vendorId: SqlField;
  public amount: SqlField;
  public isAuto: SqlField;
  public bookingMilestone: SqlNavHybrid;
  public bookingPackage: SqlNavHybrid;
  public createdByUser: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public vendor: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('bookingMilestoneShare', 'guid', '', 'id', 'bookingMilestoneShare_guid');
    this.bookingMilestoneId = new SqlField('bookingMilestoneShare', 'bookingMilestoneId', 'bookingMilestone', 'id', 'bookingMilestoneShare_bookingMilestone');
    this.bookingPackageId = new SqlField('bookingMilestoneShare', 'bookingPackageId', 'bookingPackage', 'id', 'bookingMilestoneShare_bookingPackage');
    this.vendorId = new SqlField('bookingMilestoneShare', 'vendorId', 'vendor', 'id', 'bookingMilestoneShare_vendor');
    this.amount = new SqlField('bookingMilestoneShare', 'amount', '', 'id', 'bookingMilestoneShare_amount');
    this.isAuto = new SqlField('bookingMilestoneShare', 'isAuto', '', 'id', 'bookingMilestoneShare_isAuto');
    this.bookingMilestone = createNavHybrid('bookingMilestoneShare', 'bookingMilestoneShare_bookingMilestone', 'BookingMilestone');
    this.bookingPackage = createNavHybrid('bookingMilestoneShare', 'bookingMilestoneShare_bookingPackage', 'BookingPackage');
    this.createdByUser = createNavHybrid('bookingMilestoneShare', 'bookingMilestoneShare_createdByUser', 'User');
    this.updatedByUser = createNavHybrid('bookingMilestoneShare', 'bookingMilestoneShare_updatedByUser', 'User');
    this.vendor = createNavHybrid('bookingMilestoneShare', 'bookingMilestoneShare_vendor', 'Vendor');
    this.id = new SqlField('bookingMilestoneShare', 'id', '', 'id', 'bookingMilestoneShare_id');
    this.isDeleted = new SqlField('bookingMilestoneShare', 'isDeleted', '', 'id', 'bookingMilestoneShare_isDeleted');
    this.createdBy = new SqlField('bookingMilestoneShare', 'createdBy', '', 'id', 'bookingMilestoneShare_createdBy');
    this.createdDate = new SqlField('bookingMilestoneShare', 'createdDate', '', 'id', 'bookingMilestoneShare_createdDate');
    this.updatedBy = new SqlField('bookingMilestoneShare', 'updatedBy', '', 'id', 'bookingMilestoneShare_updatedBy');
    this.updatedDate = new SqlField('bookingMilestoneShare', 'updatedDate', '', 'id', 'bookingMilestoneShare_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:BookingMilestoneShareSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:BookingMilestoneShareSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:BookingMilestoneShareSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:BookingMilestoneShareSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:BookingMilestoneShareSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:BookingMilestoneShareSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:BookingMilestoneShareSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:BookingMilestoneShareSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:BookingMilestoneShareSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:BookingMilestoneShareSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
